import { render, staticRenderFns } from "./FooterAirbnb.vue?vue&type=template&id=48427a7c&"
import script from "./FooterAirbnb.vue?vue&type=script&lang=js&"
export * from "./FooterAirbnb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports